import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, Theme } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import useDeleteAdminBoxes from 'admin/useDeleteAdminBoxes';
import React from 'react';

interface Props {
  isOpen: boolean;
  boxIds: number[];
  onDeleteSuccess: () => void;
  onCancelDelete: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  deleteBtn: {
    backgroundColor: theme.palette.error.dark,
  },
}));

const DeleteConfirmDialog = ({
  isOpen,
  onDeleteSuccess,
  boxIds,
  onCancelDelete,
}: Props) => {
  const classes = useStyles();

  const [deleteBoxMutation, { isIdle }] = useDeleteAdminBoxes(onDeleteSuccess);

  const onConfirmClick = () => {
    deleteBoxMutation({ boxIds });
  };

  return (
    <>
      <Dialog
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        open={isOpen}
        closeAfterTransition
        onClose={onCancelDelete}
      >
        <DialogTitle id="confirmation-dialog-title">
          ボックスを削除しますか？
        </DialogTitle>
        <DialogActions>
          <Button autoFocus onClick={onCancelDelete}>
            キャンセル
          </Button>
          <Button
            onClick={onConfirmClick}
            className={classes.deleteBtn}
            variant="contained"
            color="secondary"
            startIcon={<DeleteIcon />}
            disabled={!isIdle}
          >
            削除する
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteConfirmDialog;
